var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('editor',{attrs:{"init":_vm.tinyConfig},model:{value:(_vm.local),callback:function ($$v) {_vm.local=$$v},expression:"local"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }